import { render, staticRenderFns } from "./SetRedelivery.vue?vue&type=template&id=da7abb0e&"
import script from "./SetRedelivery.vue?vue&type=script&lang=js&"
export * from "./SetRedelivery.vue?vue&type=script&lang=js&"
import style0 from "./SetRedelivery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports